/* Styles */
import "@mdi/font/css/materialdesignicons.css";

/* Core */
import Vue from "vue";
import Buefy from "buefy";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
/* Router & Store */
import router from "./router";
import store from "./store";

/* Service Worker */
// import "./registerServiceWorker";
import firebase from "firebase/app";
import "firebase/auth";
import { config } from "./helpers/firebaseConfig";

/* Vue. Main component */
import App from "./App.vue";

//import "@/scss/main.scss";

/* Vue. Component in recursion */
import AsideMenuList from "@/modules/global/components/aside-menu/AsideMenuList.vue";
import "@/modules/auth/services/form.validators.js";

/* Collapse mobile aside menu on route change */
// router.afterEach(() => {
//   store.commit("asideMobileStateToggle", false);
// });

Vue.config.productionTip = false;

firebase.initializeApp(config);
firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        let userID = user.uid;
        let userEmail = user.email;
        Sentry.setTag("user_id", userID);
        Sentry.setTag("user_email", userEmail);
      }
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

Vue.config.errorHandler = function(err, vm) {
  if (err.message === "Failed to fetch" || err.name === "TimeoutError") {
    vm.$dialog.alert({
      title: "Error",
      message: `Looks like we can't reach our servers. Are you sure you are connected?`,
      type: "is-danger",
      hasIcon: true,
      icon: "exclamation-triangle"
    });
  } else {
    throw err;
  }
};

/* These components are used in recursion algorithm */
Vue.component("AsideMenuList", AsideMenuList);

Vue.use(Buefy);

var pjson = require("../package.json");

if (
  process.env.NODE_ENV === "production" ||
  process.env.NODE_ENV === "staging"
) {
  Sentry.init({
    release: `reflective-learning-dashboard-frontend@${pjson.version}`,
    dsn:
      "https://43de1229062b4cdeb8c41d7238937e38@o417210.ingest.sentry.io/5809549",
    integrations: [
      new VueIntegration({ Vue, attachProps: true, logErrors: true })
    ]
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
